/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PostCustomerOrderFormInput = {|
  attachments?: ?$ReadOnlyArray<?any>,
  company: string,
  email: string,
  location?: ?string,
  message?: ?string,
  name: string,
  telephone: string,
|};
export type PostCustomerOrderFormMutationVariables = {|
  input: PostCustomerOrderFormInput
|};
export type PostCustomerOrderFormMutationResponse = {|
  +postCustomerOrderForm: ?{|
    +result: ?boolean
  |}
|};
export type PostCustomerOrderFormMutation = {|
  variables: PostCustomerOrderFormMutationVariables,
  response: PostCustomerOrderFormMutationResponse,
|};
*/


/*
mutation PostCustomerOrderFormMutation(
  $input: PostCustomerOrderFormInput!
) {
  postCustomerOrderForm(input: $input) {
    result
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PostCustomerOrderFormPayload",
    "kind": "LinkedField",
    "name": "postCustomerOrderForm",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PostCustomerOrderFormMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PostCustomerOrderFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b47279dfc7c641166a2ff802cab8041d",
    "id": null,
    "metadata": {},
    "name": "PostCustomerOrderFormMutation",
    "operationKind": "mutation",
    "text": "mutation PostCustomerOrderFormMutation(\n  $input: PostCustomerOrderFormInput!\n) {\n  postCustomerOrderForm(input: $input) {\n    result\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '987f77becbdf2e2d0dd512cfb8a454f2';

module.exports = node;
